import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PhoneNumberFormat } from "src/app/models/customer/phone-number-format";
import { CustomerService } from "src/app/services/customer/customer.service";
import { FormatService } from "src/app/services/format/format.service";
import { environment } from "src/environments/environment";

@Injectable()
export class PhoneNumberFormatResolver  {

    constructor(private customerService: CustomerService, private formatService: FormatService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<PhoneNumberFormat>> {
        const response = this.customerService.getPhoneNumberFormat().pipe(map(response => {
            let format = null;
            if (response.success) {
                format = response.payload;
                format.phoneNumberFormat = this.formatService.validatePhoneNumberFormat(format.phoneNumberFormat);
            }
            else {
                format = <PhoneNumberFormat>{ phoneNumberFormat: environment.DEFAULT_PHONE_NUMBER_FORMAT };
            }
            return format;
        }));
        const responsePromise = new Promise<Observable<PhoneNumberFormat>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }
}
